"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CheckboxIconContainerComponent;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _DoneIcon = _interopRequireDefault(require("../../svg/DoneIcon"));
var _SvgIcon = _interopRequireDefault(require("../SvgIcon"));
var _Button = _interopRequireDefault(require("../Button"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["getCheckboxIconButtonProps", "children", "active", "disabled", "size", "variant", "color"];
function CheckboxIconContainerComponent(p) {
  var _p$getCheckboxIconBut = p.getCheckboxIconButtonProps,
    getCheckboxIconButtonProps = _p$getCheckboxIconBut === void 0 ? function () {
      return {};
    } : _p$getCheckboxIconBut,
    children = p.children,
    active = p.active,
    disabled = p.disabled,
    size = p.size,
    variant = p.variant,
    color = p.color,
    props = (0, _objectWithoutProperties2["default"])(p, _excluded);
  var defaultButtonProps = {
    Component: 'div',
    size: 'checkbox-' + size.split('-')[1],
    variant: ['contained', 'outlined'].indexOf(variant) > -1 ? variant : 'contained',
    color: disabled ? 'disabled' : color,
    icon: active ? /*#__PURE__*/_react["default"].createElement(_DoneIcon["default"], null) : /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], null),
    active: active,
    style: (0, _objectSpread2["default"])({
      transition: 'none'
    }, disabled ? {
      pointerEvents: 'none'
    } : {})
  };
  return /*#__PURE__*/_react["default"].createElement("div", props, /*#__PURE__*/_react["default"].createElement(_Button["default"], Object.assign({}, defaultButtonProps, getCheckboxIconButtonProps({
    defaultButtonProps: defaultButtonProps,
    active: active,
    disabled: disabled,
    size: size,
    variant: variant,
    color: color
  }))));
}